import React, { useEffect } from 'react';
import Spinner from '../../../components/Spinner';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { LoaderIcon } from 'react-hot-toast';
import { useMutation } from 'react-query';
import { exams } from '../../../api/exams';
import { useDispatch } from 'react-redux';
import { clearFlaggedQuestion } from '../../../features/candidate-exam/candidate-exam-slice';

const Redirect = () => {
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');
    const name = searchParams.get('name');
    const assessment_id = searchParams.get('assessment_id');
    const key = searchParams.get('key');
    const password = searchParams.get('password');
    const navigate = useNavigate() 
    const dispatch = useDispatch()
    const {mutate, isLoading} = useMutation(exams.initiateAssessment, 
      {
        onSuccess: (data) => {
          const response = data
           sessionStorage.setItem("guestUserExamId", response?.data?.user?.user_exam_id);
            dispatch(clearFlaggedQuestion(null));
            sessionStorage.setItem("userToken", response.data.token);
            sessionStorage.setItem("user_id", response?.data?.user?.user_id)
            sessionStorage.setItem("user", JSON.stringify(response?.data?.user));
            sessionStorage.setItem('attempt_count', response?.data?.exam?.number_of_attempts)
            window.sessionStorage.setItem("active-assessment-id", response?.data?.user?.exam_id);
            window.sessionStorage.setItem("active-assessment-user-id", response?.data?.user?.user_exam_id);
            window.sessionStorage.setItem("active-assessment", JSON.stringify(response?.data?.exam));
            window.sessionStorage.setItem("time_left", response?.data?.exam?.time_left);
            window.sessionStorage.setItem("duration", response?.data?.exam?.duration);
            window.sessionStorage.setItem("ql", response?.data?.exam?.number_of_questions);

            window.sessionStorage.setItem("starting-index", response?.data?.exam?.number_of_questions_answered);
            // navigate("/candidate/assessments/instructions");
            if (response?.data?.show_candidate_result) {
              return navigate('/candidate/exam-history');
            }
            sessionStorage.setItem("loginType", 'join');
            sessionStorage.setItem("joinType", 'normal');
            sessionStorage.setItem('from', 'ssh')
              sessionStorage.setItem("rejoinUser", '0')
            if(!response?.data?.redirect_to_results) {
              return navigate('/candidate/assessments/instructions')
            }
            if (response?.data?.exam?.number_of_attempts < response?.data?.exam?.number_of_attempts_allowed) {
              sessionStorage.setItem('attempt_count', response?.data?.exam?.number_of_attempts)
              navigate(`/candidate/assessments/instructions`)
            } else {
              navigate('/candidate/exam-history')
            }
            }
        }
    )

  useEffect( () => {
     //console.log({email, name, assessment_id, key});
     if(email && name && assessment_id && key && password){
       mutate({email, name, assessment_id, key, password})
     }
  }, [] )

  return (
    <section className='mt-12'>
            {  !isLoading ? null :
             <div>
                <Spinner text={
                   <div className='text-center mx-auto'>
                      <LoaderIcon style={{fontSize: 50}} className='text-white h-[50px] w-[50px] text-3xl ml-5 text-center' />
                     <h5 className='text-center'>Verifying...</h5>
                   </div>
                } />
            </div>
            }
    </section>
  )
}

export default Redirect